
import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  name: "ToTopBtn",
  computed: mapGetters("app", ["getCookie"])
})
export default class ToTopBtn extends Vue {
  isShow: boolean = false;
  isFooter: boolean = false;

  mounted() {
    this.initListener();
  }

  initListener() {
    window.addEventListener("scroll", this.handleScroll);
  }

  handleScroll() {
    this.isShow = window.pageYOffset > 200;
    let footer = document.querySelector(".footer");
    let footerScroll = footer
      ? footer["offsetTop"]
      : document.body.offsetHeight - 80;
    const html = document.getElementsByTagName("html")[0];
    if (
      html.classList.contains("firefox") &&
      window.pageYOffset + window.screen.height >= footerScroll + 94
    ) {
      this.isFooter = true;
    } else if (
      window.pageYOffset + window.innerHeight >= footerScroll &&
      !html.classList.contains("firefox")
    ) {
      this.isFooter = true;
    } else {
      this.isFooter = false;
    }
  }
}
